import * as React from 'react';
import {useCallback, useContext, useEffect, useMemo, useState} from 'react';
import {AppContext, Api} from "../../context/AppContext";
import UtilTimer from "@dia-ui/util_timer";
import {ModelUser} from "@dia-ui/util_interlink-api";
import DiaImpersonateAdapter from "@dia-ui/bundle/dist/collection/components/impersonate/src/adapter/DiaImpersonateAdapter";

export const Impersonation = () => {
  const {
    setLoading,
    services: {
      serviceAuth
    }
  } = useContext(AppContext);

  /**
   * user
   */
  const [user, setUser] = useState<ModelUser>();

  /**
   * token
   */
  const [token, setToken] = useState<string | undefined>();

  /**
   * refresh
   */
  const refresh = useCallback(async () => {
    setLoading(true);

    await UtilTimer.delay(() => {
      window.location.reload();
    }, 1000);
  }, [setLoading]);

  /**
   * load
   */
  const load = useCallback(async () => {
    await customElements.whenDefined('dia-impersonate');
    const impersonate = document.querySelector('dia-impersonate');

    if(impersonate && token) {
      // @ts-ignore
      await impersonate.initialize("interlink", token, Api);

      impersonate.addEventListener("diaImpersonationStart", refresh);
      impersonate.addEventListener("diaImpersonationStop", refresh);
    }
  }, [refresh, token]);

  /**
   * loadUser
   */
  const loadUser = useCallback(() => {
    const storedUser = serviceAuth.getUser();
    const storedToken = serviceAuth.getToken();

    if (storedUser && storedToken) {
      setUser(storedUser);
      setToken(storedToken);
    }
  }, [setToken, setUser, serviceAuth]);

  /**
   *
   */
  useEffect(() => {
    if (!token && !user) {
      let inter= setInterval(async () => {
        loadUser();
        if (inter) {
          clearInterval(inter);
        }
      }, 250);

      return;
    }
  }, [loadUser, token, user]);

  useEffect(() => {
    load();
  }, [load]);

  /**
   * return
   */
  return useMemo(() => (
    // @ts-ignore
    token && (user?.hasPermission(16) || localStorage.getItem('dia:impersonate')) ? <dia-impersonate></dia-impersonate> : <></>
  ), [token, user]);
};

/**
 * ImpersonateDestroy
 * @constructor
 */
export const ImpersonateDestroy = () => {
  DiaImpersonateAdapter.destroy();
};
